export const REDX_PANEL_PERMISSION = '/redx';
// eslint-disable-next-line
export const navigateOveride = (path: string, href: boolean) => {
  if (typeof path === 'string' && path.includes(REDX_PANEL_PERMISSION)) {
    window.location.href = '/';
    return true;
  }
  return false;
};
